import React, { useState, useEffect, useRef } from "react";
import { IconButton } from "../input/IconButton";
import { ReactComponent as CloseIcon } from "../icons/Close.svg";
import styles from "./IframeLinkModal.scss";
import classNames from "classnames";
import { useObjectList } from "./useObjectList";

import { PDF2DView } from "./2d-pdf-screen";
import { Fullscreen2DLayout } from "../layout/Fullscreen2DLayout";
import styles2D from "./2d-media.scss";

function Image2DView({ close, src, sidebar, name }) {
  return (
    <>
      <Fullscreen2DLayout
        className={classNames(styles.layout, sidebar ? "sidebar" : "", "transparency")}
        contentClassName={classNames(styles.content, styles2D.layout)}
        headerClassName={styles.header}
        headerRight={
          <IconButton onClick={close}>
            <CloseIcon fill="white" />
          </IconButton>
        }
        headerCenter={<div className={styles2D.headerTitle}>{name}</div>}
      >
        <div className={styles2D.imageContainer}>
          <img src={src}></img>
        </div>
      </Fullscreen2DLayout>
    </>
  );
}

function Video2DView({ close, src, sidebar, name }) {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const videoRef = useRef(null);

  const togglePlayPause = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
    setIsPlaying(!isPlaying);
    setIsHovered(true);
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <>
      <Fullscreen2DLayout
        className={classNames(styles.layout, sidebar ? "sidebar" : "", "transparency")}
        contentClassName={classNames(styles.content, styles2D.layout)}
        headerClassName={styles.header}
        headerCenter={<div className={styles2D.headerTitle}>{name}</div>}
        headerRight={
          <IconButton onClick={close}>
            <CloseIcon fill="white" />
          </IconButton>
        }
      >
        <div className={styles2D.videoContainer}>
          <video ref={videoRef} src={src} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}></video>
          {!isPlaying && (
            <button className={classNames(styles2D.playPauseButton)} onClick={togglePlayPause}>
              <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" fill="none">
                <g clip-path="url(#clip0_4197_8961)">
                  <path
                    d="M48 8C25.92 8 8 25.92 8 48C8 70.08 25.92 88 48 88C70.08 88 88 70.08 88 48C88 25.92 70.08 8 48 8Z"
                    fill="white"
                  />
                  <path d="M40 66L64 48L40 30V66Z" fill="#FE12A8" />
                </g>
                <defs>
                  <clipPath id="clip0_4197_8961">
                    <rect width="96" height="96" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          )}
          {isPlaying && isHovered && (
            <button
              className={classNames(styles2D.playPauseButton, "pause")}
              onClick={togglePlayPause}
              onMouseEnter={handleMouseEnter}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" fill="none">
                <g clip-path="url(#clip0_4193_3129)">
                  <path
                    d="M48 8C25.92 8 8 25.92 8 48C8 70.08 25.92 88 48 88C70.08 88 88 70.08 88 48C88 25.92 70.08 8 48 8Z"
                    fill="white"
                  />
                  <path d="M35 64H43.6667V32H35V64ZM52.3333 32V64H61V32H52.3333Z" fill="#FE12A8" />
                </g>
                <defs>
                  <clipPath id="clip0_4193_3129">
                    <rect width="96" height="96" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          )}
        </div>
      </Fullscreen2DLayout>
    </>
  );
}

export function Component2DView({ scene, object, sidebar, isMobile, breakpoint }) {
  function getFilename(url) {
    // Extract the path from the URL
    let path = new URL(url).pathname;
    // Decode the URI components
    let decodedPath = decodeURIComponent(path);
    // Split the path into components
    let pathComponents = decodedPath.split("/");
    // Get the last component (the filename)
    let filename = pathComponents[pathComponents.length - 1];
    // Remove the extension
    let filenameWithoutExtension = filename.split(".").slice(0, -1).join(".");
    return filenameWithoutExtension;
  }
  const { deselectObject, unfocusObject, selectedObject, unfocusAndDeselectObject } = useObjectList();
  const src = object?.el?.components["media-loader"]?.data?.src;
  const filename = getFilename(src);

  const close = async () => {
    unfocusAndDeselectObject();
  };

  const inVR = APP.scene?.is("vr-mode");

  if(inVR) return <></>;

  return (
    <>
      {object.type == "video" && <Video2DView close={close} name={filename} src={src} sidebar={sidebar}></Video2DView>}
      {object.type == "pdf" && <PDF2DView close={close} name={filename} src={src} sidebar={sidebar}></PDF2DView>}
      {object.type == "image" && <Image2DView close={close} name={filename} src={src} sidebar={sidebar}></Image2DView>}
    </>
  );
}
